import { flowGptApi } from '../apis';
export const inquireFlowGpt = (payload) => {
    return flowGptApi.post('/1/inquire', {
        question: payload.message,
        prompt_version: 2,
        use_memory: true,
        context: true,
        session_id: payload.sessionId,
        site_id: payload.siteId,
        product: payload.currentApp.toLowerCase(),
    });
};
export const sendFlowGptFeedback = (payload) => {
    return flowGptApi.post('/user_feedback', {
        site_id: payload.siteId,
        task_id: payload.taskId,
        feedback: payload.feedback,
    });
};
export const fetchChatHistory = (siteId) => {
    return flowGptApi.get(`/site/${siteId}/chats`);
};
